import { useParams } from "react-router";
import t from "@/lang/lang";
import { ProcessContactsPage } from "@/routes/processes/[processId]/_components/process-contacts-page";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { HtzBreadcrumbs } from "@/routes/processes/[processId]/htz/_components/htz-breadcrumbs";

export default function ContactRoute() {
  const { processId } = useParams();
  const { data: process } = useProcessesProcessShowQuery({ id: processId! });

  if (!process) return null;

  const breadcrumbs = (
    <HtzBreadcrumbs customerId={process.customerId} processId={process.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Ansprechpartner")}</BreadcrumbPage>
      </BreadcrumbItem>
    </HtzBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <ProcessContactsPage processId={processId!} />
    </ProcessPageMainTemplate>
  );
}
